import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./HomePage.css";
import { useAuth } from "../../authContext/AuthContext";
import HomeIcon from "../../assets/Logo-iMedX.png";
import searchIcon from "../../assets/Group 11.png";
import lockIcon from "../../assets/lock.png";
import rocketIcon from "../../assets/Group 13.png";
import workflowIcon from "../../assets/Group 3.png";
import assistIcon from "../../assets/Group 6.png";
import plusIcon from "../../assets/Group 17.png";
import codieIcon from "../../assets/conversationznew.png";
import paperIcon from "../../assets/Group 13.png";
import { useNavigate } from "react-router-dom";
import { Container, Row, Col, Card } from "react-bootstrap";
import HomeNotification from "./HomeNotification";
import { setHomepageCodieQuestion } from "./redux/HomePageSlice";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';

const initialTasksData = {
  tasks: [
    {
      id: "12345",
      specialty: "Cardiology",
      dischargeDate: "04.03.25",
      status: "ON HOLD",
      module: "Code Accelerate",
    },
    {
      id: "16372",
      specialty: "ENT",
      dischargeDate: "23.05.25",
      status: "AWAITING AUDIT",
      module: "Code Accelerate",
    },
    {
      specialty: "National Coding Advice",
      module: "Code Workflow",
    },
    {
      specialty: "Audit: BUPA RRPA",
      module: "Code Enhance",
    },
    {
      specialty: "Add Task",
      module: "Code Enhance",
    },
  ],
};
const DashboardHome = () => {
  const { userEmail } = useAuth();
  const [codieInput, setCodieInput] = useState("");
  const dispatch = useDispatch();
  const codieInputState = useSelector(
    (state) => state.codieStateofHomepage.homepageCodieQuestion
  );
  const name = String(userEmail)?.split("@")[0];
  const displayName = name.charAt(0).toUpperCase() + name.slice(1);
  const permissions = JSON.parse(sessionStorage.getItem("permissions")) || {};
  const navigate = useNavigate();
  const [tasks, setTasks] = useState(
    initialTasksData.tasks.filter(
      (task) => permissions[task.module] || permissions["admin"]
    )
  );
 const cardConfig = [
    {
      key: "Code Enhance",
      title: "Code Enhance",
      description: "Audit coded episodes",
      icon: plusIcon,
      linkText: "Learn More",
      route: "/Discovery",
      demoUrl:"https://acs-demo-videos.s3.us-east-1.amazonaws.com/Code_Enhance.mp4"
    },
    {
      key: "Code Accelerate",
      title: "Code Accelerate",
      description: "Validate auto coding",
      icon: rocketIcon,
      linkText: "Demo today",
      route: "/Episode-list",
      demoUrl:"https://acs-demo-videos.s3.us-east-1.amazonaws.com/Code_Accelerate.mp4"
    },
    {
      key: "Code Workflow",
      title: "Code Workflow",
      description: "Review daily tasks",
      icon: workflowIcon,
      linkText: "Learn more",
      route: "/HIM-Workspace",
      demoUrl:"https://acs-demo-videos.s3.us-east-1.amazonaws.com/Code_Workflow.mp4"
    },
    {
      key: "Code Assist",
      title: "Code Assist",
      description: "Coding and grouping tool",
      icon: assistIcon,
      linkText: "Demo today",
      route: "/Code-Assist-Episode-list",
      demoUrl:"https://acs-demo-videos.s3.us-east-1.amazonaws.com/Code_Assist.mp4"
    },
    // {
    //   key: "Codie",
    //   title: "Codie",
    //   description: "AI for Medical Coding",
    //   icon: searchIcon,
    //   linkText: "Learn More",
    //   route: "/Discovery",
    // },
  ];
  const isAdmin = permissions["admin"] === true;
  const hasWorkflowAccess =
    permissions["Code Workflow Coder"] ||
    permissions["Code Workflow Auditor"] ||
    (permissions["Code Workflow"] &&
      Array.isArray(permissions["Code Workflow"]) &&
      permissions["Code Workflow"].length > 0) ||
    permissions["Code Workflow HIM"] ||
    isAdmin;
  const getWorkflowRoute = () => {
    if (
      (permissions["Code Workflow"] &&
        Array.isArray(permissions["Code Workflow"]) &&
        permissions["Code Workflow"].length > 0) ||
      permissions["Code Workflow HIM"]
    ) {
      return "/Code-Workflow"; // First priority (includes Code Workflow HIM)
    } else if (permissions["Code Workflow Coder"]) {
      return "/Coder-Workspace"; // Second priority
    } else if (permissions["Code Workflow Auditor"]) {
      return "/Auditor-Workspace"; // Third priority
    }
    return null; // No access
  };
  const hasAnyModuleAccess =
    isAdmin || cardConfig.some((card) => !!permissions[card.key]);
  const handleCardClick = (route, hasAccess) => {
    if (hasAccess) {
      navigate(route); // Navigate to the module's route if user has access
    }
  };
 
  const hidenavigationFigiEnv = process.env.REACT_APP_FLAG_FIJI_DEV;
  const hidenavigatehealthecareEnv = process.env.REACT_APP_FLAG_HEALTHECARE;
  console.log(hidenavigatehealthecareEnv,hidenavigationFigiEnv,"hidenavigatehealthecareEnv")
 
  const accessibleModules = cardConfig
    .filter((card) => isAdmin || permissions[card.key])
    .map((card) => card.key);
 
  const handleHomepageCodieChange = (e) => {
    dispatch(setHomepageCodieQuestion(e.target.value));
  };
  const handleHometoCodieNav = (e) => {
    if (e.key === "Enter") {
      navigate("/Codie");
    }
  };
  return (
    <Container fluid className="p-4 dashboard-home">
      {/* Header */}
      <div className="text-center mb-4">
        <img
          src={HomeIcon}
          alt="logo"
          className="homelogo-icon"
          // style={{ width: "260px", height: "110px", marginTop: "20px", objectFit: "contain" }}
        />
        <h5 className="homepageheader">HIM Companion Suite</h5>
        <h6 className="home-user-content text-muted">Welcome, {displayName}</h6>
      </div>
      {/* <div className="d-flex justify-content-center mb-4">
        <div className="codie-input-wrapper">
          <img src={searchIcon} alt="ask" className="codie-input-icon" />
          <input
            type="text"
            value={codieInputState??""}
            className="form-control codie-real-input"
            placeholder="Trial Codie today, type your question"
            disabled={!hasAnyModuleAccess} // Example: Disable based on permission
            onChange={handleHomepageCodieChange}
            onKeyDown={handleHometoCodieNav}
          />
          {!hasAnyModuleAccess && (
            <img src={lockIcon} alt="lock" className="codie-input-end-icon" />
          )}
         
          <a  href="https://acs-demo-videos.s3.us-east-1.amazonaws.com/Codie.mp4"
            target="_blank"
            rel="noopener noreferrer"
            className="home-card-link"
            style={{ margin: "0px 8px", cursor: "pointer", color: "black", textDecoration: "none" }}
          >
            <div style={{ display: "flex",justifyContent:"space-between", alignItems: "center" }}>
              <PlayCircleOutlineIcon />
              <span style={{ marginLeft: 4 }}>Demo</span>
            </div>
          </a>
 
        </div>
      </div> */}
 
      <div className="homepage-card-row">
        {cardConfig.map((card, idx) => {
          // const hasAccess = isAdmin || permissions[card.key];
          const hasAccess =
            isAdmin ||
            (card.key === "Code Workflow"
              ? hasWorkflowAccess
              : permissions[card.key]);
          // const hasAccess =
          //   card.key === "Code Assist"
          //     ? false // only this special case
          //     : isAdmin ||
          //     (card.key === "Code Workflow"
          //       ? hasWorkflowAccess
          //       : permissions[card.key]);
          const cardClass = hasAccess
            ? "cards-list1 text-white"
            : "cards-list2";
          const workflowRoute =
            card.key === "Code Workflow" ? getWorkflowRoute() : card.route;
          if (
           ( hidenavigationFigiEnv &&
            ["Code Accelerate", "Code Assist", "Code Workflow"].includes(
              card.title
            )|| (hidenavigatehealthecareEnv &&
    ["Code Accelerate", "Code Assist"].includes(card.title))
)
          ) {
            return null;
          }
          return (
            <div key={idx}>
              {!(
           (hidenavigationFigiEnv &&
           ["Code Accelerate", "Code Assist", "Code Workflow"].includes(card.title)) ||
          (hidenavigatehealthecareEnv &&
            ["Code Accelerate", "Code Assist","Code Workflow"].includes(card.title))
         ) && (
                <Card className={`${cardClass} home-card-conatiner`}>
                  <Card.Body className="home-container">
                  <div>
                    <div
                        className={`home-card-icon ${
                          hasAccess ? "pink-icon" : "blue-icon"
                        }`}
                      >
                        <img src={card.icon} alt="icon" />
                      </div>
                    <Card.Title className="home-card-title">
                      {card.title}
                    </Card.Title>
                    <Card.Text className="home-card-text">
                      {card.description}
                    </Card.Text>
                  </div>
                    <div className="home-card-action-row">
                    <div>
                                            {!hasAccess && (
                        <img src={lockIcon} alt="lock" className="lock-icon" />
                      )}
                      <span
                        className="home-card-link"
                        onClick={() =>
                          handleCardClick(workflowRoute, hasAccess)
                        }
                        style={{ cursor: hasAccess ? "pointer" : "default" }}
                      >
                        {hasAccess ? "Launch" : card.linkText}
                      </span>
                    </div>
                    <a  href={card.demoUrl}
                       target="_blank"
                       rel="noopener noreferrer"
                       className="home-card-link"
                       style={{ display:hasAccess?"flex":"none",margin: "0px 8px", cursor: "pointer", color: "black", textDecoration: "none" }}
                    >
                    <span
                        className="home-card-link"
                       
                        style={{  margin:"0px 8px",cursor:"pointer"}}
                      >
                       <div style={{display:"flex",alignItems:"center"}}><PlayCircleOutlineIcon/>
                        Demo</div>
                      </span>
                      </a>
                     
                    </div>
                  </Card.Body>
                </Card>
              )}
            </div>
          );
        })}
      </div>
      {/* {accessibleModules.length > 0 && tasks.length > 0 && (
        <HomeNotification tasks={tasks} accessibleModules={accessibleModules} />
      )} */}
    </Container>
  );
};
 
export default DashboardHome;